import { HighContrastSelector } from '@fluentui/react';
import { FluentV9ColorTokens, HighContrastColors, ThemeColorPalette, ThemeColorPaletteShared } from '@fluidx/component-ux';
export const containerToolbarButtonStyles = {
    root: {
        height: 44,
        width: 44,
        color: `var(${FluentV9ColorTokens.colorNeutralForeground2}, ${ThemeColorPaletteShared.Gray4})`,
        [HighContrastSelector]: {
            color: HighContrastColors.Text
        }
    },
    rootDisabled: {
        background: 'transparent',
        color: `var(${FluentV9ColorTokens.colorNeutralForegroundDisabled}, ${ThemeColorPaletteShared.Gray4})`
    },
    rootHovered: {
        backgroundColor: `var(${FluentV9ColorTokens.colorSubtleBackgroundHover}, ${ThemeColorPalette.Neutral.neutralLighter})`,
        color: `var(${FluentV9ColorTokens.colorNeutralForeground2BrandHover}, ${ThemeColorPaletteShared.Gray4})`
    },
    rootPressed: {
        backgroundColor: `var(${FluentV9ColorTokens.colorSubtleBackgroundPressed}, ${ThemeColorPalette.Neutral.neutralLight})`,
        color: `var(${FluentV9ColorTokens.colorNeutralForeground2BrandPressed}, ${ThemeColorPaletteShared.Gray4})`
    },
    icon: {
        fontSize: '20px',
        width: 20,
        height: 20,
        lineHeight: 20
    }
};
